export default __webpack_public_path__ + "static/media/slide2.5996040a.webp";